// extracted by mini-css-extract-plugin
module.exports =  {"SelectorButton":"LszOwZOxq2pl4aLTb8wQ","SelectorButton__Switch":"SEMN9HQSU6mzAdEMNA5x","SelectorButton__List":"PNlpGsrlUACMOXeztAUr"};